export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const SET_EVENT_TYPE = 'SET_EVENT_TYPE';
export const RESET = 'RESET';
export const HIDE_SUCCESS_SCREEN = 'HIDE_SUCCESS_SCREEN';
export const SET_EMPLOYEE_LOCATION_INFO = 'SET_EMPLOYEE_LOCATION_INFO';
